import Tag from '../reusable/Tag';

interface TranscriptSelectionStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
}

export const getTranscriptSelectionStatusDisplay = (
  status: string | null
): { text: string; type: 'pending' | 'completed' | 'progress' } => {
  switch (status) {
    case 'DATA_QC_NOT_COMPLETED':
      return { text: 'Not available', type: 'pending' };
    case 'TRANSCRIPT_SELECTION_NOT_STARTED':
      return { text: 'Not started', type: 'pending' };
    case 'TRANSCRIPT_SELECTION_IN_PROGRESS':
      return { text: 'In progress', type: 'progress' };
    case 'TRANSCRIPT_SELECTION_COMPLETED':
      return { text: 'Ready for Lead Facilitator review', type: 'progress' };
    case 'TRANSCRIPT_SELECTION_FINALIZED':
      return { text: 'Approved', type: 'completed' };
    default:
      return { text: 'Not available', type: 'pending' };
  }
};

const TranscriptSelectionStatus = ({ status, size = 'small', className }: TranscriptSelectionStatusProps) => {
  const { text, type } = getTranscriptSelectionStatusDisplay(status);
  return <Tag type={type} text={text} size={size} className={className} />;
};

export default TranscriptSelectionStatus;
